import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import "./RankCard.css";
import { useNavigate } from "react-router-dom";

const RankCard = () => {
  const navigate = useNavigate();
  return (
    <div className="rank-card" onClick={() => navigate("/rank-rewards")}>
      <div className="rank-content">
        <div className="rank-left">
          <p className="rank-label">Current Rank</p>

          <div className="rank-row">
            <div className="rank-badge">
              <img src="images/profile/Layer.png" alt="layer" />
            </div>

            <div>
              <h3 className="rank-title">My Customers</h3>
              <p className="rank-desc">
                Begin your journey and plant the seed of success
              </p>
            </div>
          </div>
        </div>
        <div className="rank-right">
          <button className="rank-btn">
            Rank History{" "}
            <span>
              <FontAwesomeIcon className="arrow" icon={faArrowRight} />
            </span>
          </button>
        </div>
        <div className="rank-number">01</div>
      </div>
    </div>
  );
};

export default RankCard;
